import axios from 'axios';
import { parseCookies, setCookie } from 'nookies'
import qs from 'querystring';
import { rollbar } from '../context/rollbar';

const tokenLifeTime = 30;

const apiHost = 'https://cloud.squidex.io';
const contentUrl = '/api/content/ruharp/';
const clientId = 'ruharp:api';
const clientSecret = '534pb7txlrlsfkn2ldpggc4rkngwyuzcsqp7eol7j3ox';
const accessTokenCookieName = 'ruharp.contentAccessToken';

export default class SquidexRepository {

    static getTokenFromCache(nextContext) {
        return parseCookies(nextContext)[accessTokenCookieName];
    }

    static setTokenToCache(nextContext, token) {
        setCookie(
            nextContext,
            accessTokenCookieName,
            token,
            {
                maxAge: tokenLifeTime * 24 * 60 * 60,
                path: '/',
                sameSite: true,
            }
        );
    }

    static async requestAccessToken() {
        try {
            const data = {
                grant_type: 'client_credentials',
                scope: 'squidex-api',
                client_id: clientId,
                client_secret: clientSecret,
            };

            const response = await axios({
                method: 'POST',
                url: `${apiHost}/identity-server/connect/token`,
                data: qs.stringify(data),
            });

            const token = response.data.access_token;

            if (!token) {
                throw new Error('Unable to retrieve access token');
            }

            return token;

        } catch (error) {
            rollbar.error(error, 'Access token request failed');
        }
    }

    static async doAuthRequest(accessToken, url, params = {}, options = {}) {
        try {
            return await axios({
                method: 'GET',
                url: `${apiHost}${url}`,
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
                ...options,
                params,
            });
        } catch (error) {
            if (error.response.status !== 401) {
                rollbar.error(`Auth request response: ${JSON.stringify(error)}`);
            }

            return error.response;
        }
    }

    static async request(nextContext, type, params = {}, options = {}) {
        let token = this.getTokenFromCache(nextContext);

        if (!token) {
            token = await this.requestAccessToken(clientId, clientSecret);

            this.setTokenToCache(nextContext, token, tokenLifeTime)
        }

        let response = await this.doAuthRequest(token, contentUrl + type, params, options);

        if (response.status === 401) {
            token = await this.requestAccessToken(nextContext, clientId, clientSecret);
            this.setTokenToCache(nextContext, token, tokenLifeTime);

            response = await this.doAuthRequest(token, contentUrl + type, params, options);
        }

        if (response.status !== 200) {
            rollbar.error(`Unexpected response: ${JSON.stringify(response)}`);
            return undefined;
        }

        return response.data;
    }

    static async getMusicians(nextContext) {
        const result = await this.request(nextContext, 'music', { $orderby: 'data/order/iv asc' });

        if (!Array.isArray(result.items)) {
            return [];
        }

        return result.items.map((item) => {
            return {
                ...item.data,
                photo: `${apiHost}/api/assets/${item.data.photo.iv[0]}`
            }
        });
    }
}
